import React, { useState, useEffect } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import "./businessDetails.css";
import { Container, Row, Col } from "react-bootstrap";
import { baseUrl } from "../../../../network/constants/constants";
import config, { getConfig } from "../../../../network/auth";
import axios from "../../../../network/api";
import BusinessDetForm from "../forms/businessDetForm/businessDetForm";
import { Spinner } from "react-bootstrap";
import AppConstants from "../../../AppConstants";
import { Snackbar, Alert, Button } from "@mui/material";
import GeoMap from "./geomap/geomap";
import { useMemo } from "react";
import BusinessLocation from "./businessLocation/businessLocation";

export const BusinessDetails = () => {
  const [businessDetail, setBusinessDetail] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const [geoMapEditable, setGeoMapEditable] = useState(false);
  const [businessLocationEditable, setBusinessLocationEditable] =
    useState(false);

  const [polygonPoints, setPolygonPoints] = useState("");
  const [businessPoints, setBusinessPoints] = useState("");
  const [fullScreenStates, setFullScreenStates] = useState({
    geoMap: false,
    businessLocation: false,
  });

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleGeoMapEdit = () => setGeoMapEditable(!geoMapEditable);
  const handleBusinessLocationEdit = () =>
    setBusinessLocationEditable(!businessLocationEditable);

  const [selected, setSelected] = useState(1);

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  const config = useMemo(() => {
    return getConfig();
  }, []);

  const bID = localStorage.getItem(AppConstants.business_id);
  const fetchBusinessDetails = () => {
    setLoading(true);
    axios
      .get(baseUrl + `businessadmin/businesses-by-owner/`, config)
      .then((response) => {
        setBusinessDetail(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Categories Error:", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchBusinessDetails();
  }, []);

  const editBusinessDetails = (updatedData) => {
    setLoading(true);

    const dataToSend = {
      ...updatedData,
      location: polygonPoints,
      business_location: businessPoints,
    };
    axios
      .post(
        baseUrl + `businessadmin/businesses-edit/${bID}`,
        dataToSend,
        config
      )
      .then((response) => {
        fetchBusinessDetails();
        showSnackbar(response.data.message, "success");
        setOpen(false);
      })
      .catch((error) => {
        showSnackbar(error.status, "error");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleOpenForm = () => {
    setOpen(true);
  };

  const handleCloseForm = () => {
    setOpen(false);
  };

  const toggleFullScreen = (mapName) => {
    setFullScreenStates((prevState) => ({
      ...prevState,
      [mapName]: !prevState[mapName],
    }));
  };

  return (
    <Container fluid>
      <button className="btn-add" onClick={handleOpenForm}>
        Edit Franchisee Details
      </button>
      {loading ? (
        <div className="loader-container">
          <Spinner className="spinner-loader" />
        </div>
      ) : (
        <>
          <Row>
            <Col md={5}>
              <Card sx={{ Width: 275 }}>
                <CardContent>
                  <Typography variant="h6" sx={{ textAlign: "start", mb: 1.5 }}>
                  Franchisee Details
                  </Typography>

                  <div className="key-value">
                    <div className="key">Franchisee Name :</div>
                    <div className="value">{businessDetail.business_title}</div>
                  </div>
                  <div className="key-value">
                    <div className="key">Franchisee Place :</div>
                    <div className="value">{businessDetail.place}</div>
                  </div>
                  <div className="key-value">
                    <div className="key">Mobile Number :</div>
                    <div className="value">{businessDetail.mobile_number}</div>
                  </div>
                  <div className="key-value">
                    <div className="key">Franchisee Description :</div>
                    <div className="value">{businessDetail.description}</div>
                  </div>
                </CardContent>
              </Card>
            </Col>
          </Row>
          <Row className="mt-5">
            <Col lg={12}>
              <Card sx={{ Width: 275 }} className="p-3 mb-3">
                <Row>
                  <Col>
                    <Typography
                      variant="h6"
                      sx={{ textAlign: "start", mb: 1.5 }}
                    >
                      Edit Service Location
                    </Typography>
                  </Col>
                  <Col className="d-flex justify-content-end mb-2">
                    <Button
                      variant="contained"
                      color= {fullScreenStates.geoMap ? "primary" : "secondary"}
                      onClick={() => toggleFullScreen("geoMap")}
                    >
                      {fullScreenStates.geoMap
                        ? "Exit Full Screen"
                        : "Go Full Screen"}
                    </Button>
                  </Col>
                </Row>

                <GeoMap
                  location={businessDetail.location}
                  editable={geoMapEditable}
                  onEditToggle={handleGeoMapEdit}
                  setPolygonPoints={setPolygonPoints}
                  selected={selected}
                  setSelected={setSelected}
                  isFullScreen={fullScreenStates.geoMap}
                />
              </Card>
            </Col>
            <Col lg={12} >
              <Card sx={{ Width: 275 }} className="p-3">
                <Row>
                  <Col>
                    <Typography
                      variant="h6"
                      sx={{ textAlign: "start", mb: 1.5 }}
                    >
                      Edit Franchisee Location
                    </Typography>
                  </Col>
                  <Col className="d-flex justify-content-end mb-2">
                    <Button
                      variant="contained"
                      color= {fullScreenStates.businessLocation ? "primary" : "secondary"}
                      onClick={() => toggleFullScreen("businessLocation")}
                    >
                      {fullScreenStates.businessLocation
                        ? "Exit Full Screen"
                        : "Go Full Screen"}
                    </Button>
                  </Col>
                </Row>

                <BusinessLocation
                  businessLocation={businessDetail.business_location}
                  editable={businessLocationEditable}
                  onEditToggle={handleBusinessLocationEdit}
                  setBusinessPoints={setBusinessPoints}
                  selected={selected}
                  setSelected={setSelected}
                  isFullScreen={fullScreenStates.businessLocation}
                />
              </Card>
            </Col>
          </Row>
        </>
      )}
      <BusinessDetForm
        open={open}
        onClose={handleCloseForm}
        isEdit
        businessData={businessDetail}
        onSubmit={editBusinessDetails}
      />

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default BusinessDetails;
